import { InjectionToken } from '@angular/core';

export interface LoadingConfig {
    container?: any;
    message?: string;
    position?: string;
    template?: string;
}

export const loaddingDefaultConfig = {
    container: 'body',
    message: '正在加载中，请稍候...',
    posion: 'center'
};

export const LOADING_DEFAULT_CONFIG = new InjectionToken<LoadingConfig>('loading default options.');
